export const LoadingState = () => {
    return (
      <div className="loader-state">
          <div className="state-loading"><span className="loader-two"></span></div>
          <center className="fixed-bottom title">APEII - ASOCIACIÓN PERUANA DE INGENIERÍA INDUSTRIAL</center>
      </div>
    );
  }
  
  export default LoadingState;